const ColumnType = {
    DATE: 0,
    ENUM: 1,
    STRING: 2,
    NUMBER: 3,
    ACTION: 4, // this type of column is for row actions, i.e. context menu, clear button etc.
    BOOL: 5,
    COMPANY: 6,
    SELECT: 7,
    MULTIPLE_VALUE: 8,
    RANGE: 9,
    CUSTOM: 10,
    COMPLEX_SEARCH: 11,
    TAGS: 12,
    COMPLEX_ENUM_FILTER: 13,
    EDITABLE_SELECT : 14,
    CHECKBOX : 15,
}

const OnlineStatus = {
    OFFLINE: 0,
    ONLINE: 1
}

const BestInstallationStatus = {
    NOT_INSTALLED: 0,
    INSTALLED: 1
}

const MachineType = {
    WINDOWS: 0,
    MAC: 1,
    LINUX: 2
}

const InventoryEntityType = {
    UNDEFINED: 0,
    COMPANY: 1,
    GROUP: 2,
    ENDPOINT: 3
}

const KaseyaInventoryItemType = {
    UNDEFINED: 0,
    ORGANIZATION: 1,
    SITE: 2,
    GROUP: 3,
    DEVICE: 4
}

const AssociationDataFilterType = {
    VsaOrganizationIdsFilter: 0,
    VsaCompanyNameFilter: 1,
    GzCompanyNameFilter: 2
}

const InventoryEntities = [
    {
        label: 'Company',
        value: 1
    },
    {
        label: 'Group',
        value: 2
    }
]

const GzCompanyType = {
    PARTNER: 0,
    CUSTOMER: 1
}

const OperationType = {
    SYNC: 0,
    ASSOCIATE: 1,
    DELETE_ASSOCIATION: 2
}

const ProductType = {
    ENDPOINT_SECURITY: 0,
    BITDEFENDER_EDR: 3
}

const PackageConfigurationLevel = {
    Group: 0,
    Company: 1
}

const FeaturesSyncMode = {
    Package: 0,
    Policy: 1
}

const PackageDownloadMethod = {
    SetupDownloader: 0,
    FullKit: 1
}

const InventoryEventTypes = {
    UNKNOWN: 0,
    DESTINATION_MOVED: 1,
    DESTINATION_DELETED: 2,
    MISSING_ASSOCIATION_FOUND: 3,
    ELIGIBLE_FOR_UPGRADE: 4,
    DESTINATION_GENESIS: 5,
    SOURCE_DELETED: 6,
    THE_BIG_CRUNCH: 7
}

const AgentEventTypes = {
    UNKNOWN: 1,
    DESTINATION_MOVED: 2,
    ROGUE_AGENT: 3,
    DESTINATION_DELETED: 4,
    MISSING_ASSOCIATION: 5,
    DESTINATION_GENESIS: 6,
    SOURCE_DELETED: 7,
}

const EventActionTypesLabel = [
    {
        label: "Auto",
        value: 1
    },
    {
        label: "Manual",
        value: 2
    },
    {
        label: "Ignore",
        value: 3
    },
]


const InventoryEventLabels = [
    {
        label: "Destination Moved",
        value: 1
    },
    {
        label: "Destination Deleted",
        value: 2
    },
    {
        label: "Missing Association Found",
        value: 3
    },
    {
        label: "Missing Prefix-based Association Found",
        value: 4
    },
    {
        label: "Destination Creation",
        value: 5
    },
    {
        label: "Source Gone",
        value: 6
    },
    {
        label: "Association Deleted (Source and Destination Missing)",
        value: 7
    },
]

const AgentInventoryEventLabels = [
    {
        label: "Destination Moved",
        value: 2
    },
    {
        label: "Rogue Bitdefender Agent Found",
        value: 3
    },
    {
        label: "Destination Deleted",
        value: 4
    },
    {
        label: "Missing Association",
        value: 5
    },
    {
        label: "Install Bitdefender Agent",
        value: 6
    },
    {
        label: "Source Deleted",
        value: 7
    },
]

const EventActionTypes = {
    UNDEFINED : 0,
    AUTO: 1,
    MANUAL: 2,
    IGNORE: 3
}

const TaskType = {
    INVENTORY: 'inventory',
    AGENT: 'agent'
}

const TaskStatusType = {
    RUNNING: 2,
    SUCCEEDED: 4,
    FAILED: 5
}

const ExclusionType = {
    InventorySync: 1,
    EndpointsSync: 2
}

const OsType = [
    {
        label: "Windows",
        value: "windows"
    },
    {
        label: "Linux",
        value: "linux"
    },
    {
        label: "Mac",
        value: "mac"
    }
]

const ExcludedEnum = {
    ExcludedFromSync: 0,
    IncludedInSync: 1
}

const ExcludedValues = [
    {
        label: "Yes",
        value: ExcludedEnum.ExcludedFromSync
    },
    {
        label: "No",
        value: ExcludedEnum.IncludedInSync
    }
]

const InstallStates = {
    NotInstalled: 0,
    Installed: 1,
    InstalledWithServicesNotRunning: 2,
    RebootRequired: 3,
    InstalledWithoutFeatures: 4,
    DetectPending: 5,
    InstallPending: 6,
    UninstallPending: 7
}

const InstallStatesValues = [
    {
        label: "Not Installed",
        value: InstallStates.NotInstalled
    },
    {
        label: "Installed",
        value: InstallStates.Installed
    },
    {
        label: "Installed With Services Not Running",
        value: InstallStates.InstalledWithServicesNotRunning
    },
    {
        label: "Reboot Required",
        value: InstallStates.RebootRequired
    },
    {
        label: "Installed Without Features",
        value: InstallStates.InstalledWithoutFeatures
    },
    {
        label: "Detect Pending",
        value: InstallStates.DetectPending
    },
    {
        label: "Install Pending",
        value: InstallStates.InstallPending
    },
    {
        label: "Uninstall Pending",
        value: InstallStates.UninstallPending
    }
]

const SyncOperationType = {
    InventorySync: 'syncInventory',
    InventorySyncExclusion: 'handleInventorySyncExclusion',
    SyncAgents: 'syncAgents',
    SyncAgentsExclusion: 'handleAgentsSyncExclusion'
}

const ExclusionActionType = {
    INCLUDE: 0,
    EXCLUDE: 1
}

export {
    ColumnType,
    OnlineStatus,
    BestInstallationStatus,
    MachineType,
    InventoryEntities,
    InventoryEntityType,
    InventoryEventLabels,
    InventoryEventTypes,
    OperationType,
    ProductType,
    PackageConfigurationLevel,
    FeaturesSyncMode,
    EventActionTypes,
    TaskType,
    TaskStatusType,
    PackageDownloadMethod,
    ExclusionType,
    KaseyaInventoryItemType,
    OsType,
    AgentEventTypes,
    AgentInventoryEventLabels,
    EventActionTypesLabel,
    SyncOperationType,
    ExcludedValues,
    ExcludedEnum,
    InstallStatesValues,
    InstallStates,
    ExclusionActionType,
    GzCompanyType,
    AssociationDataFilterType
};